import { useContactModal } from "@/core/providers/ContactModalContext";
import { useContent } from "@/shared/lib/i18n";

export function Cta() {
  const { openModal } = useContactModal();
  const { cta } = useContent();
  const titleLines = cta.title.split("\n");

  return (
    <section className="py-8 px-[14px] lg:px-20" id="contact">
      <div className="mx-auto max-w-[1760px]">
        {/* Mobile coin — outside overflow-hidden block */}
        <div className="relative lg:hidden flex justify-center">
          <img
            src="/decorations/coin_1.webp"
            alt=""
            className="relative z-10 w-[155px] mb-[-70px] pointer-events-none select-none"
          />
        </div>

        <div className="relative overflow-hidden rounded-2xl py-14 lg:py-20 px-6 lg:px-8">
          {/* Amber background */}
          <div
            className="absolute inset-0"
            style={{ background: "linear-gradient(135deg, #f89a09 0%, #fec201 50%, #f4a425 100%)" }}
          />

          {/* Subtle texture overlay */}
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage:
                "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.3) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(0,0,0,0.2) 0%, transparent 50%)",
            }}
          />

          {/* Left coin — desktop only */}
          <img
            src="/decorations/coin_1.webp"
            alt=""
            className="hidden lg:block absolute left-12 top-1/2 -translate-y-1/2 w-[160px] pointer-events-none select-none"
          />

          {/* Right coin — desktop only */}
          <img
            src="/decorations/coin_2.webp"
            alt=""
            className="hidden lg:block absolute -right-32 -bottom-32 w-[400px] pointer-events-none select-none"
          />

          {/* Content */}
          <div className="relative mx-auto max-w-[700px] text-center">
            <h2 className="font-display text-[32px] lg:text-[52px] font-bold leading-tight text-[#070707] mb-4">
              {titleLines[0]}
              <br />
              {titleLines[1]}
            </h2>
            <p className="text-[15px] text-[#070707]/70 mb-8 lg:mb-10 leading-relaxed lg:max-w-[480px] mx-auto">
              {cta.subtitle}
            </p>
            <button
              onClick={openModal}
              className="flex lg:inline-flex items-center justify-center h-14 px-12 rounded-full text-base font-semibold text-white transition-all hover:scale-105"
              style={{ background: "#070707", boxShadow: "0 8px 32px rgba(0,0,0,0.3)" }}
            >
              {cta.cta}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
